module.exports = __webpack_public_path__ + "img/model7.2c64cf53.png";